import {
  getRequestDataFormat,
  statesType,
} from '@zet/customer/src/utils/addCustomerStates'
import { zetApi } from '@zet/network'

export interface IRequestData {
  fullName?: string
  phoneNumber?: string
  categoryId?: string
  customerId?: number
  panNo?: string
  otp?: string
  employmentType?: string
  bankNameList?: string[]
  currentOccupation?: string
  annualIncome?: string
  modeOfIncome?: number
  dob?: string
  pinCode?: string
  email?: string
  gender?: number
  screenName?: string
  partnerId?: number
  hash?: string
  isReconsentFlow?: boolean
  isVerifyOtpOnly?: boolean
  customerIntent?: string
  event?: string | null
  triggerSend?: string | null | undefined
  isCreditCheck?: boolean
  nonVerifiedBridgeCustomerAddition?: boolean
  customerAdditionSource?: string
  isDemoSale?: boolean
  subAgentId?: number
  nonVerfiedUser?: boolean
  secondaryPhoneNumber?: string | null
  jfsConsent?: object
  monthlyIncome?: number
}

interface ActionData {
  lockedTill: string
  customerId: number
  reason: string
  panNo: string
}

interface ResponseData {
  action: statesType
  actionData: ActionData
}

export type IResponseData = {
  data: ResponseData
  error?: object
}

const getNextStateAddCustomerState = async (requestData: IRequestData) => {
  const {
    customerPayload,
    userState,
    bureauReportConsent,
    partnerId,
    event,
    triggerSend,
    isCreditCheck,
    nonVerifiedBridgeCustomerAddition,
    subagentId,
  } = getRequestDataFormat(requestData)

  const { data } = await zetApi.post<IResponseData>(
    requestData?.categoryId
      ? `eventHandle/getNextStateAddCustomer?categoryId=${requestData?.categoryId}`
      : 'eventHandle/getNextStateAddCustomer',
    {
      customerPayload,
      userState,
      ...(bureauReportConsent ? { bureauReportConsent } : {}),
      ...(partnerId ? { partnerId } : {}),
      ...(event ? { event } : {}),
      ...(triggerSend ? { triggerSend } : {}),
      ...(isCreditCheck ? { isCreditCheck } : {}),
      ...(nonVerifiedBridgeCustomerAddition
        ? { nonVerifiedBridgeCustomerAddition }
        : {}),
      ...(subagentId ? { subagentId } : {}),
    }
  )
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}

export { getNextStateAddCustomerState }
